import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import { BREAKPOINTS } from '../constants/ui';

const BeforeAfterGallery = () => {
  const { language, t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [slidesPerView, setSlidesPerView] = useState(3);

  const galleryItems = [
    {
      id: 1, name: 'Ignacio V.', age: 35, grafts: 3500,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/oplqb1gh_paciente_real_antes.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/6hidgylr_paciente_real_despues.png',
      testimonial: language === 'en'
        ? 'Total transformation. From advanced baldness to full hair. The best medical team!'
        : 'Transformación total. De calvicie avanzada a cabello completo. ¡El mejor equipo médico!'
    },
    {
      id: 2, name: 'Ana M.', age: 52, grafts: 800,
      procedure: language === 'en' ? 'Eyebrow Graft' : 'Injerto de Cejas',
      beforeImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/7do5jtgs_Antes_preparado.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/xo97752k_despues_preparado.png',
      testimonial: language === 'en'
        ? 'Incredible transformation. My eyebrows look natural and defined. Very happy with the result!'
        : 'Increíble transformación. Mis cejas lucen naturales y definidas. ¡Muy feliz con el resultado!'
    },
    {
      id: 3, name: 'Marco R.', age: 22, grafts: 2000,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/snevxpfz_marcos_antes.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/kzssv1gx_marcos_despues.png',
      testimonial: language === 'en'
        ? 'Incredible result. My hairline looks completely natural. Thank you Bianhi!'
        : 'Resultado increíble. Mi línea frontal luce completamente natural. ¡Gracias Bianhi!'
    },
    {
      id: 4, name: 'Gonzalez E', age: 28, grafts: 2000,
      procedure: language === 'en' ? 'Beard Graft' : 'Injerto de Barba',
      beforeImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/2jdc0d65_paciente_barbaantes.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/y57d0w9c_barba_despues.jpg',
      testimonial: language === 'en'
        ? 'Now I have the beard I always wanted. Perfect design and very natural. Excellent work!'
        : 'Ahora tengo la barba que siempre quise. Diseño perfecto y muy natural. ¡Excelente trabajo!'
    },
    {
      id: 5, name: 'Marco R.', age: 22, grafts: 2000,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/i8q6g6fq_MARCO_superior_ANTES.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/7qznxj35_MARCO_superior_DESPUES.png',
      testimonial: language === 'en'
        ? 'Top view - The density achieved by the Bianhi team exceeded my expectations.'
        : 'Vista superior - La densidad que logró el equipo de Bianhi superó mis expectativas.'
    },
    {
      id: 6, name: 'Carlos M', age: 35, grafts: 2200,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/bm96qorp_llanos_antes.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/rqofri0i_llanos_despues.png',
      testimonial: language === 'en'
        ? 'Incredible coverage. The frontal area has perfect density. Very satisfied!'
        : 'Increíble cobertura. La zona frontal quedó con una densidad perfecta. ¡Muy satisfecho!'
    },
    {
      id: 7, name: 'Guerra A', age: 54, grafts: 3500,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/qw2hexjo_chavez_antes.png',
      afterImage: 'https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/quetv8h0_chavez_despues.png',
      testimonial: language === 'en'
        ? 'Excellent result at my age. I recovered volume and naturalness. Totally recommended!'
        : 'Excelente resultado a mi edad. Recuperé volumen y naturalidad. ¡Totalmente recomendado!'
    },
    {
      id: 8, name: 'Brandom R.', age: 28, grafts: 2000,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/dtgbur84_paciente_antes.JPG',
      afterImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/o7j6b3gd_Paciente_despues.JPG',
      testimonial: language === 'en'
        ? 'Its been four months since my surgery, and Im thrilled with the results!'
        : '4 meses doctora y amando mi resultado!'
    },
    {
      id: 9, name: 'Brandom R.', age: 28, grafts: 2000,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/n0r61b61_diseno_despues.JPG',
      afterImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/o10bwkqo_diseno_antes.jpeg',
      testimonial: language === 'en'
        ? 'Its been four months since my surgery, and Im thrilled with the results!'
        : '4 meses doctora y amando mi resultado!'
    },
    {
      id: 10, name: 'Paciente 001', age: null, grafts: null,
      procedure: language === 'en' ? 'Hair Transplant' : 'Trasplante Capilar',
      beforeImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/92ikxgma_IMG_8702.JPG.jpeg',
      afterImage: 'https://customer-assets.emergentagent.com/job_09e286d1-4c20-47f6-af67-b64662bd6215/artifacts/n2690mq5_IMG_8706.JPG.jpeg',
      testimonial: language === 'en'
        ? 'Amazing transformation. Natural hairline and excellent density. Highly recommended!'
        : 'Transformación increíble. Línea frontal natural y excelente densidad. ¡Muy recomendado!'
    }
  ];

  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(window.innerWidth < BREAKPOINTS.TABLET ? 1 : 3);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = Math.max(0, galleryItems.length - slidesPerView);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <section id="resultados" className="py-20 md:py-28 bg-white" data-testid="before-after-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-semibold tracking-wider uppercase text-[#009d9f] mb-4">
            {t('gallery.tagline')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {t('gallery.title')}{' '}
            <span className="text-[#009d9f]">{t('gallery.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-slate-600">{t('gallery.description')}</p>
        </div>

        <div className="relative" data-testid="gallery-carousel">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#009d9f] hover:text-white transition-all border border-slate-200"
            data-testid="gallery-prev-btn"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#009d9f] hover:text-white transition-all border border-slate-200"
            data-testid="gallery-next-btn"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          <div className="overflow-hidden px-8">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * (100 / slidesPerView)}%)` }}
            >
              {galleryItems.map((item, index) => (
                <div
                  key={item.id}
                  className="flex-shrink-0 px-3"
                  style={{ width: `${100 / slidesPerView}%` }}
                >
                  <div
                    className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-300"
                    onMouseEnter={() => setHoveredCard(item.id)}
                    onMouseLeave={() => setHoveredCard(null)}
                    data-testid={`gallery-card-${index}`}
                  >
                    <div className="relative h-72 overflow-hidden">
                      <div className={`absolute inset-0 transition-opacity duration-500 ${hoveredCard === item.id ? 'opacity-0' : 'opacity-100'}`}>
                        <img src={item.beforeImage} alt={`${item.name} ${t('gallery.before').toLowerCase()}`} className="w-full h-full object-cover grayscale" loading="lazy" />
                        <div className="absolute top-4 left-4 bg-slate-900/80 text-white text-xs font-semibold px-3 py-1.5 rounded-full">
                          {t('gallery.before')}
                        </div>
                      </div>
                      <div className={`absolute inset-0 transition-opacity duration-500 ${hoveredCard === item.id ? 'opacity-100' : 'opacity-0'}`}>
                        <img src={item.afterImage} alt={`${item.name} ${t('gallery.after').toLowerCase()}`} className="w-full h-full object-cover" loading="lazy" />
                        <div className="absolute top-4 left-4 bg-[#009d9f] text-white text-xs font-semibold px-3 py-1.5 rounded-full">
                          {t('gallery.after')}
                        </div>
                      </div>
                      <div className={`absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-sm text-slate-700 text-xs font-medium px-3 py-1.5 rounded-full transition-opacity ${hoveredCard === item.id ? 'opacity-0' : 'opacity-100'}`}>
                        {t('gallery.hoverHint')}
                      </div>
                    </div>

                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <h3 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{item.name}</h3>
                          <p className="text-sm text-slate-500">{item.age ? `${item.age} ${t('gallery.years')}` : ''}</p>
                        </div>
                        <div className="flex">
                          {[...Array(5)].map((_, i) => (
                            <Star key={`gallery-star-${item.id}-${i}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                          ))}
                        </div>
                      </div>
                      <div className="flex items-center gap-4 mb-4">
                        <span className="text-xs font-semibold text-[#009d9f] bg-[#CCFBF1] px-3 py-1 rounded-full">{item.procedure}</span>
                        {item.grafts && <span className="text-xs font-medium text-slate-500">{item.grafts.toLocaleString()} {t('gallery.grafts')}</span>}
                      </div>
                      <p className="text-slate-600 text-sm italic">"{item.testimonial}"</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, index) => (
            <button
              key={`gallery-dot-${index}`}
              onClick={() => setCurrentIndex(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentIndex ? 'bg-[#009d9f] w-8' : 'bg-slate-300 hover:bg-slate-400'}`}
              data-testid={`gallery-dot-${index}`}
            />
          ))}
        </div>

        <div className="text-center mt-12">
          <Button 
            onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-[#009d9f] hover:bg-[#008486] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-[#009d9f]/20 transition-all hover:-translate-y-0.5"
            data-testid="gallery-cta-btn"
          >
            {t('gallery.cta')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterGallery;
